import { Formik, Form } from 'formik';
import {
    initialValues,
    validationSchema_20940,
} from 'blocks/Form/data/validation';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import Phone from 'blocks/Form/fields/Phone';
import Location from 'blocks/Form/fields/Location';
import MarketingRequested from 'blocks/Form/fields/MarketingRequested';
import Submit from 'blocks/Form/fields/Submit';
import Text from 'components/Formik/Text';
import TextArea from 'components/Formik/TextArea';

/* === GSC - Supplier Application - 20940 === */

const Form20940 = ({ handleSubmit, isPending, language, fields }) => {
    const {
        first_name,
        last_name,
        email_address,
        location,
        phone,
        marketing_requested,
        submit,
        company_name,
        dba_name,
        if_applicable,
        products_or_services_your_company_provides,
        list_of_active_diverse_or_small_business_certifications,
        validation,
    } = fields;

    initialValues.Account_official_name__c = '';
    initialValues.Litmos__User_Id__c = '';
    initialValues.Product__c = '';
    initialValues.Board_Certified_In__c = '';
    initialValues.Company = '';

    return (
        <>
            {fields && (
                <Formik
                    initialValues={initialValues}
                    onSubmit={(values) => handleSubmit('marketo', values)}
                    validationSchema={validationSchema_20940(
                        validation,
                        language
                    )}
                >
                    {(formik) => (
                        <Form className="form form--lg">
                            <div className="grid-lg-1 row-gap-0">
                                <FirstName
                                    label={first_name}
                                    initialValues={initialValues}
                                />
                                <LastName
                                    label={last_name}
                                    initialValues={initialValues}
                                />
                                <Email
                                    label={email_address}
                                    initialValues={initialValues}
                                />
                                <Phone
                                    label={phone}
                                    initialValues={initialValues}
                                />
                                <Text label={company_name} name="Company" />
                                <Text
                                    label={dba_name}
                                    name="Account_official_name__c"
                                    helper={if_applicable}
                                />
                                <Text
                                    label="Duns & Bradstret ID"
                                    name="Litmos__User_Id__c"
                                    helper={if_applicable}
                                />
                                <Location
                                    data={location}
                                    formik={formik}
                                    initialValues={initialValues}
                                />
                                <Text
                                    label={
                                        products_or_services_your_company_provides
                                    }
                                    name="Product__c"
                                />
                                <TextArea
                                    label={
                                        list_of_active_diverse_or_small_business_certifications
                                    }
                                    name="Board_Certified_In__c"
                                />
                                <MarketingRequested
                                    formik={formik}
                                    initialValues={initialValues}
                                    data={marketing_requested}
                                />
                            </div>
                            <Submit
                                formik={formik}
                                isPending={isPending}
                                pendingText={submit.submitting}
                                validation={submit.all_required_fields}
                            >
                                {submit.submit}
                            </Submit>
                        </Form>
                    )}
                </Formik>
            )}
        </>
    );
};

export default Form20940;
